
import { axiosGet, axiosPost } from '../AxiosRequests';
//*** Lib */
import {
    GetAllModuleNameList, GetModuleFileNameList, DeleteFileByModuleType, GetAllMainModuleNameList
} from '../ApiEndPoints';

export default class FileManagerServices {

    async getAllMainModuleNameList(request) {
        return axiosGet(GetAllMainModuleNameList, request);
    }

    async getAllModuleNameList(request) {
        return axiosGet(GetAllModuleNameList, request);
    }

    async getModuleFileNameList(request) {
        return axiosPost(GetModuleFileNameList, request);
    }

    async deleteFileByModuleType(request) {
        return axiosPost(DeleteFileByModuleType, request);
    }

}

